module.exports = __webpack_public_path__ + "static/media/serializd.f4dc0b80.svg";